import { render } from "./verification.vue?vue&type=template&id=135aa826"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__